import React, { useState, useEffect } from 'react';
import { Search, Plus, Download, Filter} from 'lucide-react';
import { useDispatch, useSelector } from "react-redux";
import { getLoadList } from '../../redux/Load/actions';
import FileUpload from '../FileUpload/FileUpload';
import { DataTable } from '../ui/table';
import Pagination from '@/pages/PortPlace/Pagination';
import { getLoadPlanColumns } from './columns';
import { useDebounced } from '@/hooks/useDebounced';
import { callLoader } from '@/redux/Loader/actions';

const LoadPlanList = ({ onCreateNew, onEditPlan }) => {
    const [searchText, setSearchText] = useState(null);
    const [searchField, setSearchField] = useState('all');
    const [selectedPlans, setSelectedPlans] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize,setPageSize] = useState(10)
    const [fileUploadVisible, setFileUploadVisible] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const { loadList, pagination } = useSelector((state) => state.load);
    const dispatch = useDispatch();
    const [authUser] = JSON.parse(localStorage.getItem('authUser') ?? "[{}]");
    const authName = authUser?.username;
    const companyId=authUser?.companyId;

      const debouncedSearch = useDebounced(() => {
      _getLoadList(1);
    }, 300);
    useEffect(() => {
        if(searchText === null) return;
      debouncedSearch(searchText);
    }, [searchText]);

    useEffect(() => {
        _getLoadList(1);
    }, [pageSize]);

    useEffect(() => {
        if (selectedOrderId != null) {
            setFileUploadVisible(true);
        } else {
            setFileUploadVisible(false);
        }
    }, [selectedOrderId]);

    const _getLoadList = async (page = 1) => {
   
        const payload = {
            IPageNo: page, IPageRecords: pageSize, FilterType: searchField, SearchKeyword: searchText || "",
            compnayId:companyId
        }
        try {
             dispatch(callLoader(1));
            await dispatch(getLoadList(payload));
            setCurrentPage(page)
             dispatch(callLoader(0));
        } catch (error) {
             dispatch(callLoader(0));
        }
    }

  
  const handlePageSize = (size) => {
    setPageSize(size);
  };
  const changePage = (page) => {
   _getLoadList(page)
  };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedPlans(loadList?.map(plan => plan.loId));
        } else {
            setSelectedPlans([]);
        }
    };

    const handleSelectPlan = (planId) => {
        if (selectedPlans.includes(planId)) {
            setSelectedPlans(selectedPlans.filter(id => id !== planId));
        } else {
            setSelectedPlans([...selectedPlans, planId]);
        }
    };

const columns = getLoadPlanColumns({
  selectedPlans,
  loadList,
  handleSelectAll,
  handleSelectPlan,
  onEditPlan,
  setSelectedOrderId,
});
    return (
        <div className="min-h-full">
            {/* Compact Header */}
            <div className="flex items-center justify-between mb-4">
                <div>
                    <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Load Plan List</h1>
                    <p className="text-sm text-slate-500 dark:text-slate-400 mt-0.5">{pagination?.totalRecord} total load plans</p>
                </div>
                <div className="flex items-center space-x-2">
                    <button className="px-4 py-2 text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-all flex items-center space-x-2">
                        <Download className="w-4 h-4" />
                        <span className="text-sm font-medium">Export</span>
                    </button>
                    <button className="px-4 py-2 text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-all flex items-center space-x-2">
                        <Filter className="w-4 h-4" />
                        <span className="text-sm font-medium">Filter</span>
                    </button>
                    <button
                        onClick={onCreateNew}
                        className="px-5 py-2 bg-[#0072FF] hover:bg-[#0062DD] text-white rounded-lg font-medium transition-all flex items-center space-x-2"
                    >
                        <Plus className="w-4 h-4" />
                        <span>New Load Plan</span>
                    </button>
                </div>
            </div>

            {/* Sleek Search Bar */}
            <div className="bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 p-3 mb-4">
                <div className="flex items-center space-x-2">
                    <select
                        value={searchField}
                        onChange={(e) => setSearchField(e.target.value)}
                        className="px-3 py-2 text-sm border-0 bg-slate-50 dark:bg-slate-800 rounded-lg text-slate-900 dark:text-white focus:ring-2 focus:ring-[#0072FF]"
                    >
                        <option value="all">All</option>
                        <option value="loadplan">Load Plan #</option>
                        <option value="shipment">Shipment #</option>
                        <option value="status">Status</option>
                    </select>
                  
                    <div className="relative flex-1  max-w-[400px]">
                        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400" />
                        <input
                            type="text"
                            placeholder="Enter text for search..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className="w-full pl-10 pr-4 py-2 text-sm border-0 bg-slate-50 dark:bg-slate-800 rounded-lg text-slate-900 dark:text-white placeholder-slate-400 focus:ring-2 focus:ring-[#0072FF] focus:bg-white dark:focus:bg-slate-900 transition-all"
                        />
                    </div>
                      <select
                        className="px-3 py-2 text-sm border-0 bg-slate-50 dark:bg-slate-800 rounded-lg text-slate-900 dark:text-white focus:ring-2 focus:ring-[#0072FF]"
                    >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                        <option value="all">All Status</option>
                    </select>
                  
                </div>
            </div>

            {/* Professional Data Table */}
             <DataTable
          data={loadList || []}
          columns={columns}
          boxClass="shadow-sm border border-slate-200 dark:border-slate-700"
          trClass={
            "hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors"
          }
          thClass={
            "px-3 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-400 white whitespace-nowrap uppercase tracking-wider"
          }
          tdClass=" text-sm  px-2 py-2 border-b border-slate-200 dark:border-slate-700"
          htrClass="border-b border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/50"
        />
        <Pagination
          className="border-t border-slate-200 dark:border-slate-800 pl-2 pr-16 pt-4 pb-8 mb-0 bg-slate-50 dark:bg-slate-800/50 mt-8"
          currentPage={currentPage}
          recordsPerPage={pageSize}
          setRecordsPerPage={handlePageSize}
          onPrevious={changePage}
          onNext={changePage}
          totalRecord={pagination?.totalRecord}
          handleGoto={changePage}
          title="load plans"
        />

            {
                fileUploadVisible &&
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white w-[70%] p-6 rounded-xl shadow-xl animate-fadeIn scale-100">
                        <div>
                            <FileUpload orderId={selectedOrderId?.loId} orderNum={selectedOrderId?.loNumber} type={'loadplan'} />
                        </div>
                        <div className="flex justify-end mt-6">

                            <button
                                onClick={() => { setFileUploadVisible(false); setSelectedOrderId(null); }}
                                className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default LoadPlanList;
